import React, {Component} from 'react';
import _ from 'lodash';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import renderHTML from 'react-render-html';

import QuillShiftEnter from '../../QuillShiftEnter';
import { thaiVowels } from '../../../utils/index';

const EditingFieldName = 'attachment';

export default class InlineEditAttached extends Component {
	constructor(props){
		super(props)

		this.state = {
  		value: this.props.attachment,
  		editing: false
  	}

    this.quillRef = null;      // Quill instance
    this.reactQuillRef = null; // ReactQuill component
    this.unprivilegedEditor = null; // ReactQuill component

  	this.handleChange = this.handleChange.bind(this);
  	this.handleSetValue = this.handleSetValue.bind(this);
  	this.onEditing = this.onEditing.bind(this);

    this.attachQuillRefs = this.attachQuillRefs.bind(this);
	}

  componentDidMount() {
    if(this.state.editing){
      this.attachQuillRefs()
    }
  }
  
  componentDidUpdate() {
    if(this.state.editing){
      this.attachQuillRefs()
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.loading !== nextProps.loading){
      this.setState({
        value: nextProps.attachment
      })
    }
  }

  attachQuillRefs() {
    if (typeof this.reactQuillRef.getEditor !== 'function') return;
    this.quillRef = this.reactQuillRef.getEditor();
    this.unprivilegedEditor = this.reactQuillRef.makeUnprivilegedEditor(this.quillRef);

  }

  handleChange(value) {
    this.setState({ value: value })
  }

	handleSetValue(){
    console.log('handleSetValue')
    const self = this;
    let text = this.quillRef.getText();
    const length = this.unprivilegedEditor.getLength();

    let break_indexs = []
    _.forEach(text, function(t, index){
      var bounds = self.unprivilegedEditor.getBounds(index);
      
      if ( bounds.right === 16 && index !== 0 && !thaiVowels().includes(t.charCodeAt(0)) ) {
        let prev_char = self.quillRef.getText(index - 1, 1);

        if (prev_char.charCodeAt(0) !== 10) {
          break_indexs.push(index)
        }
      }
    })

    _.forEach(break_indexs.reverse(), function(i){
      self.quillRef.insertEmbed(i, 'break', true, 'user');
    })

		const val = this.unprivilegedEditor.getHTML();
		this.setState({editing: false, value: val}, this.props.handleChange(EditingFieldName, val));
	}

	onEditing(){
  	if (this.state.editing){
    		this.setState({editing: false});
  	}else{
    		this.setState({editing: true});
  	}
	}

	stripHTML(text){
		if (_.isEmpty(text)) { return }

		var regex = /(<([^>]+)>)/ig;
 		return text.replace(regex, "");
	}

	render(){
		var attachment = this.stripHTML(this.props.attachment);
		return (
			<div className='mt-2'>
				<div className='row'>
					<div className='col-2 pr-0 attached_things_label'>
						<p>{this.props.label}</p>
					</div>
					<div className='col-10'>
						<div className='row'>
							
								{this.state.editing ? (
                  <div className='col-12'>
  									<div id="editing_attachment_id">
  										<ReactQuill 
                        ref={(el) => { this.reactQuillRef = el }}
                        value={this.state.value}
                        onChange={this.handleChange}
                        modules={QuillShiftEnter.optionsConfig} />

  								        <div className='mt-2'>
  								        	<button 
                              id="submit_edit_attachment"
  									        	type='button' 
  									        	className='btn btn-primary'
  									        	onClick={this.handleSetValue}>
  									        	ตกลง
  									        </button>
  									    </div>
                    </div>
							    </div>
								) : (
									<div className='col-12 pl-0' id="show_attachment_id">
										{attachment ? (
											<div className='pointer editing_content' onClick={this.onEditing}>
												{renderHTML(this.props.attachment)}
											</div>
										) : (
											<div className='text-danger pointer suggest_text_label' onClick={this.onEditing}>
												<p><em>{this.props.suggest_text}</em></p>
											</div>
										)}	
									</div>
								)}

						</div>
					</div>
				</div>
            </div>
		)
	}
}

document.addEventListener('click', function(event){ 
  var editing_attachment_id = document.getElementById('editing_attachment_id');
  var show_attachment_id = document.getElementById('show_attachment_id');

  if (show_attachment_id){
    if (show_attachment_id.contains(event.target)){ return }
  }

  if (editing_attachment_id){
    if (!editing_attachment_id.contains(event.target)){
      document.getElementById('submit_edit_attachment').click();
    }
  }
});


// WEBPACK FOOTER //
// ./src/components/documents/elements/InlineEditAttached.js